export default "__VITE_ASSET__XU_G0UH6__"